import type { DatabaseFile } from '../types';
import type { GitHubService } from './GitHubService';
import { imageRepoPath } from '../utils/itemImages';
import { createThumbnailFromFile, thumbnailFilename, thumbnailRepoPath } from '../utils/imageThumbnail';

export async function syncItemImagesForFile(github: GitHubService, file: DatabaseFile): Promise<void> {
  for (const path of file.orphanedImagePaths) {
    const sha = await github.getBlobSha(path);
    if (sha) await github.deleteFile(path, sha, `App: remove image ${path.split('/').pop()}`);
  }
  file.orphanedImagePaths = [];

  for (const section of file.sections) {
    for (const item of section.items) {
      for (const filename of item.imagesToDelete) {
        const path = imageRepoPath(file.path, filename);
        const sha = await github.getBlobSha(path);
        if (sha) await github.deleteFile(path, sha, `App: remove image ${filename}`);
        const thumbPath = thumbnailRepoPath(file.path, filename);
        const thumbSha = await github.getBlobSha(thumbPath);
        if (thumbSha) await github.deleteFile(thumbPath, thumbSha, `App: remove thumbnail ${thumbnailFilename(filename)}`);
        item.images = item.images.filter(f => f !== filename);
      }
      item.imagesToDelete = [];

      for (const pending of item.pendingImages) {
        const path = imageRepoPath(file.path, pending.filename);
        const buf = await pending.file.arrayBuffer();
        await github.writeBinary(path, buf, '', `App: add image ${pending.filename}`);
        try {
          const thumbBlob = await createThumbnailFromFile(pending.file);
          const thumbPath = thumbnailRepoPath(file.path, pending.filename);
          await github.writeBinary(
            thumbPath,
            await thumbBlob.arrayBuffer(),
            '',
            `App: add thumbnail ${thumbnailFilename(pending.filename)}`
          );
        } catch {
          /* HEIC/unsupported decode — gallery falls back to full image */
        }
        if (!item.images.includes(pending.filename)) item.images.push(pending.filename);
      }
      item.pendingImages = [];
    }
  }
}

export function queueOrphanedImagesForItem(file: DatabaseFile, item: { images: string[] }): void {
  for (const filename of item.images) {
    file.orphanedImagePaths.push(imageRepoPath(file.path, filename));
    file.orphanedImagePaths.push(thumbnailRepoPath(file.path, filename));
  }
}
